export default __webpack_public_path__ + "static/media/make-move.3e8866de.mp3";